import React from "react";
import "./BusyNotice.css";

// Shown when the Data API turns a request away under heavy load (HTTP 503)
function BusyNotice({ message, onRetry, minHeight }) {
  return (
    <div className="busy-notice" role="status" style={minHeight ? { minHeight } : undefined}>
      <p className="busy-notice-text">{message}</p>
      {onRetry && (
        <button type="button" className="busy-notice-retry" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

export default BusyNotice;
